import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Route, Router, RouterLink } from '@angular/router';
import { OnlineService, UpdateService } from '@nts/std/utility';
import { TokenService } from '../../auth/token.service';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { RoutingService } from '../../routing/routing.service';
import { UIStarter } from '../../starter';
import { BaseContainerComponent } from '../layout/base-container/base-container.component';
import { ToastMessageService } from '../layout/toast-message/toast-message.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';
import { NgClass } from '@angular/common';
import { AuthService } from '../../auth/auth.service';
import { TelemetryService } from '@nts/std/telemetry';
import { CurrentRouteService } from '../../routing';

@UntilDestroy()
@Component({
  selector: 'nts-entry-page',
  templateUrl: './entry-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: [
    './entry-page.component.scss'
  ],
  imports: [
    NgClass,
    RouterLink
  ]
})
export class EntryPageComponent extends BaseContainerComponent implements OnInit {

  @ViewChild('documentPlaceHolder', { read: ViewContainerRef, static: true }) override documentPlaceHolder: ViewContainerRef;

  registeredEntities = [];

  constructor(
    protected override readonly routingService: RoutingService,
    protected override readonly activatedRoute: ActivatedRoute,
    protected override readonly tokenService: TokenService,
    protected override readonly toastMessageService: ToastMessageService,
    protected override readonly updateService: UpdateService,
    protected override readonly onlineService: OnlineService,
    protected override readonly authService: AuthService,
    protected override readonly telemetryService: TelemetryService,
    protected override readonly environmentConfiguration: EnvironmentConfiguration,
    protected override readonly cd: ChangeDetectorRef,
    protected override readonly currentRouteService: CurrentRouteService,
    protected readonly router: Router,
  ) {
    super(
      routingService,
      activatedRoute,
      tokenService,
      toastMessageService,
      updateService,
      onlineService,
      authService,
      telemetryService,
      environmentConfiguration,
      cd,
      currentRouteService
    );
  }

  override async ngAfterViewInit(): Promise<void> {

    await super.ngAfterViewInit();

    window.document.title = `ENTITY LIST - ${this.environmentConfiguration.appTitle}`;

    if (this.environmentConfiguration.envType === 'PROD') {
      await UIStarter.redirectToDashboard();
      return;
    }

    const params = await firstValueFrom(this.activatedRoute.queryParams);

    if (this.environmentConfiguration.envType === 'TEST' && params['test-e2e'] !== 'true') {
      await UIStarter.redirectToDashboard();
      return;
    }

    // Se ci sono degli errori è inutile che continuo
    if (this.hasErrors) {
      return;
    }

    this.populateEntites('', this.router.config);
    this.registeredEntities.sort();
    TelemetryService.trackPageView();
    this.cd.detectChanges();
  }

  populateEntites(parent: string, config: Route[]) {
    for (let i = 0; i < config.length; i++) {
      const route = config[i];
      if (route.path !== '' && route.path.startsWith('manage/')) {
        this.registeredEntities.push(route.path.substring(route.path.indexOf('/') + 1));
      }
      if (route.children) {
        const currentPath = route.path ? parent + '/' + route.path : parent;
        this.populateEntites(currentPath, route.children);
      }
    }
  }

  protected untilDestroyed() {
    return untilDestroyed(this);
  }
}
